enum CustomFeature {
    RETURN_PARCEL_TO_REQUESTER = 'returnParcelToRequester'
}

export { CustomFeature };
